export default "__VITE_ASSET__a884043d__"